export default __webpack_public_path__ + "media/images/icons/whatsapp-5960a89532a76320347f9c0e3705417f.svg";